module.exports = __webpack_public_path__ + "img/clip.1e63374b.svg";